<section class="google-workspace-3-step">
  <div class="box">
    <div class="box-wrapper">
      <div class="box-wrapper__left">
        <div class="box-wrapper__left--title"
          ><span>{{ 'GOOGLE_WORKSPACE.3_STEP.TITLE' | translate }}</span></div
        >
        <div class="box-wrapper__left--detail">{{ 'GOOGLE_WORKSPACE.3_STEP.DETAIL' | translate }}</div>
        <div class="box-wrapper__left--btn">
          <a
            class="btn-layout"
            rel="noopener noreferrer"
            target="_blank"
            href="https://form.flowaccount.com/googleworkspace"
            ><span>{{ 'GOOGLE_WORKSPACE.3_STEP.BTN' | translate }}</span></a
          >
        </div>
      </div>
      <div class="box-wrapper__right">
        <div class="box-wrapper__right--img">
          <picture>
            <source
              [srcset]="'https://flowaccountcdn.com/new_landing/image/google-workspace/3-step/ready_to_use.png'"
              type="image/webp"
            />
            <img
              [src]="'https://flowaccountcdn.com/new_landing/image/google-workspace/3-step/ready_to_use.png'"
              [alt]="'GOOGLE_WORKSPACE.3_STEP.TITLE' | translate"
              loading="lazy"
              class="img-layout"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</section>
